import React from "react";
import {
  TabPane,
  Row,
  Col,
  Label,
} from "reactstrap";
import "./index.css";
import SiteContactView from "../../../../components/SiteContactView";
import SiteConversationView from "../../../../components/SiteConversationView";
import t from "utils/Lang";

interface LegalInformationTabProps {
  isView: boolean;
  storeData: any;
  setStoreData: Function;
}

export default function LegalInformationTab({
  isView,
  storeData,
  setStoreData,
}: LegalInformationTabProps) {
  return (
    <TabPane tabId="legal_information_tab">
      <Row>
        <Col sm={{ size: 4, offset: 0 }}>
          <Label style={styles.customTextInput}>{t().store_detail__contact}</Label>
        </Col>
        <Col sm={{ size: 8, offset: 0 }} style={styles.contactView}>
          <SiteContactView locationId={storeData?.data?.site?.id} isSite />
        </Col>
      </Row>
      <SiteConversationView {...{ siteId: storeData?.data?.site?.id }} />
    </TabPane>
  );
}

const styles = {
  customTextInput: {
    marginTop: 20,
  },
  contactView: {
    padding: 12,
  },
  conversationView: {
    padding: 12,
  },
};
